import {PaymentMethod} from '../types/payment-method';

export const paymentMethods = ['CREDIT', 'OVERPAYMENT'] as PaymentMethod[];

export const PAYMENT_METHOD = {
  CREDIT: 'CREDIT',
  OVERPAYMENT: 'OVERPAYMENT',
} as Record<Uppercase<PaymentMethod>, PaymentMethod>;
